import { Notification, Text } from '@bfa/common-ui';
import React from 'react';
var MutationNotification = function (_a) {
    var type = _a.type, message = _a.message;
    return (React.createElement(Notification, { noMarginBottom: true, scrollToOnShow: true, color: type === 'success' ? '#F1FF4C' : 'red', type: type },
        React.createElement(Text, { color: type === 'success' ? 'black' : 'white', fontFamily: "NeueEinstellung", fontSize: "1.4rem", letterSpacing: "0.02rem", lineHeight: "2.1rem", textAlign: "center", bold: true }, message)));
};
export default MutationNotification;
